const Location = () => {
  return (
    <iframe
      src='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d202.9671450244369!2d35.7751762!3d35.5172746!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1526adb7bbb71021%3A0x6b7c6929820abae1!2zR1E4RytWM1HYjCDYp9mE2YTYp9iw2YLZitipX9i02KfYsdi5INin2YTZgtiv2LNf2LnYqNin2LHYqdiMINin2YTYrdmF2LHYpywgU3lyaWE!5e0!3m2!1sen!2snl!4v1721736073058!5m2!1sen!2snl'
      width='100%'
      height='100%'
      style={{ border: 0 }}
      allowFullScreen={false}
      loading='lazy'
      referrerPolicy='no-referrer-when-downgrade'
    ></iframe>
  )
}

export default Location
